@if (pkg$ | async; as pkg) {
  <div class="layout-col full">
    <app-terminal-batch-package-detail
      class="flex"
      [package]="pkg"
      [terminalBatchCtx]="terminalBatchCtx"
      (close)="close()"
    >
    </app-terminal-batch-package-detail>
  </div>
}
